var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4058",
    "data-name": "Group 4058",
    transform: "translate(-16 -108)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(16 108)",
    fill: "#ffc522"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3968",
    "data-name": "Group 3968",
    transform: "translate(746.982 -115.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M-710.871,233.074a10.205,10.205,0,0,0-10.081,8.741h-3.03l4.371,4.37,4.37-4.37h-2.766a7.3,7.3,0,0,1,7.137-5.827,7.293,7.293,0,0,1,7.284,7.284,7.293,7.293,0,0,1-7.284,7.284,7.31,7.31,0,0,1-5.916-3.032l-2.365,1.7a10.229,10.229,0,0,0,8.28,4.244,10.21,10.21,0,0,0,10.2-10.2,10.21,10.21,0,0,0-10.2-10.2Z",
    transform: "translate(0 0)",
    fill: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M-613.684,288.223v5.924l4.349,2.609,1.5-2.5-2.935-1.761v-4.274Z",
    transform: "translate(-98.643 -49.322)",
    fill: "#1b1b1b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history_icon.5915be1576b1866721e9b8bf407bc453.svg";
export { ForwardRef as ReactComponent };